/**
 * Utility functions for formatting data
 */

/**
 * Format timestamp to DD/MM/YYYY HH:MM format
 *
 * @param timestamp - ISO 8601 timestamp string or Date object
 * @returns Formatted timestamp string (e.g., "17/04/2026 14:30")
 *
 * @example
 * formatTimestamp('2026-04-17T14:30:00Z') // => "17/04/2026 14:30"
 */
export function formatTimestamp(timestamp: string | Date): string {
  const date = typeof timestamp === 'string' ? new Date(timestamp) : timestamp;

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  return `${day}/${month}/${year} ${hours}:${minutes}`;
}
